import React, { memo, forwardRef } from "react";
const SvgAbsolute = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect width={10} height={14} x={11} y={9} fill="#DBDBDB" rx={2} />
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M9 7a1 1 0 00-2 0v18a1 1 0 102 0V7zm16 0a1 1 0 10-2 0v18a1 1 0 102 0V7z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgAbsolute.displayName = "SvgAbsolute";
const MemoForwardRef = memo(SvgAbsolute);
export default MemoForwardRef;
